import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const Loading = () => {
  return (
    <div className="loading">
      <Spin />
    </div>
  );
};

export const LoadingScreen = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 top-0 flex min-h-[100vh] items-center justify-center">
      <Spin
        size="large"
        indicator={<LoadingOutlined className="text-blue-600" />}
      />
    </div>
  );
};
